import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { config, API_URL, API_IMAGES } from '../component/include';
import { LoadEffect } from '../component/loader';
import { useParams} from 'react-router-dom';
import PageHeader from '../component/pageheader';
import { useSelector } from 'react-redux';
import { getClassName } from '../component/globalFunction';

const HomeworkPreview = () => {
  let params = useParams()

 const schoolClass  = useSelector(state => state.rootReducer.schoolClass);
const schoolInfo  = useSelector(state => state.rootReducer.schoolInfo);
  const { code } = params;

  const homework_code = localStorage.getItem('homework_code')

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [homework, setHomework] = useState(null);
  const [subjects, setSubjects] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [teacherRemarks, setTeacherRemarks] = useState('');
  const [behaviorComments, setBehaviorComments] = useState('');
  const [parentResponse, setParentResponse] = useState('');
  const printRef = useRef();




  useEffect(() => {
    if (code) {
      fetchHomeworkDetails();
    }
  }, [code]);



  const fetchHomeworkDetails = async () => {
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append('student_code', code || '');
      fd.append('homework_code', homework_code || '');

      const response = await axios.post(`${API_URL}/homework/show`, fd, config);
      if (response.data.status === 'success') {

        const homeworkData = response.data.data[0];
        setHomework(homeworkData);
        setSubjects(response.data.subject);
        
        setParentResponse(homeworkData.parent_response)
        setLoading(false);
      } else {
        setError('Failed to fetch homework details');
        setLoading(false);
      }
    } catch (error) {
      setError('Error fetching homework details');
      setLoading(false);
    }
  }




  const handleEditToggle = () => {
    setEditMode(!editMode);
    //scroll to end
    window.scrollTo(0, document.body.scrollHeight);
  };

 

  const handleSaveChanges = async () => {
    setLoading(true);
    setError('');
    
    try {

      const fd = new FormData();
      fd.append('student_code', code);
      fd.append('homework_code', homework_code);
      fd.append('parent_response', parentResponse);


     const response = await axios.post(`${API_URL}/homework/parent_response/update`, fd, config);
      
      if (response.data.status === 'success') {
      setSuccess('Changes saved successfully');
      setLoading(false);
      setEditMode(false);
      
      // Refresh homework details
      fetchHomeworkDetails();
    } else {
      setError('Failed to save changes');
      setLoading(false);
    } 

    } catch (error) {
      setError('Error saving changes');
      setLoading(false);
    }

  };





  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
  };

  const renderPrintableHomework = () => {
    if (!homework) return null;
    
    return (
      <div className="printable-homework p-4" ref={printRef}>
          {schoolInfo&&schoolInfo.map((st, id)=>
                          <div className="row" key={id}>
       
       <table className="table  table-full-width">
          <tbody>
          <tr>
          <td className="text-center" ><img id="viewSchoolLogo2" className="img-100" onError={(e)=>{e.target.onerror = null; e.target.src=API_IMAGES+'/logo.png'}} src={`${API_IMAGES}/about/${st.schoolLogo}`}  title="School Logo" alt=''  />
       <h4 style={{textAlign:'center'}}><b>{st.schoolName}</b></h4>
       <h6 style={{textAlign:'center'}}><b>Motto: {st.schoolMotto}</b></h6>
       <div style={{textAlign:'center'}}>  {st.address}, E:{st.email}  </div>
       <div style={{textAlign:'center'}}>W: {st.website} Telephone: {st.mobile}, {st.altMobile} </div>
       
        </td>
                   </tr>
               </tbody>
          </table>
       
       </div> 
                          )}
        
        <div className="student-info mb-4">
          <div className="row">
            <div className="col-md-6">
              <p><strong>Date:</strong> {formatDate(homework.homework_date)}</p>
              <p><strong>Return Date:</strong> {formatDate(homework.default_return_date)}</p>
              </div>
            <div className="col-md-6">
            <p><strong>Class:</strong> {getClassName(homework.classID, homework.sectionID, schoolClass)}</p>
          
                <p><strong>Student:</strong> {homework.studentName} ({homework.admissionNumber})</p>
         
              
            </div>
          </div>
        </div>
        
        <div className="academic-activities mb-4">
          <h5>Academic Activities</h5>
          <table className="table table-bordered">
            <thead>            <tr>
                <th>Subject</th>
                <th>Description of Homework</th>
                <th>Return Date</th>
                <th>Completion Status</th>
              </tr>
            </thead>
            <tbody>

              {subjects && subjects.map(subject => (
                <tr key={subject.code}>
                  <td>{subject.subjectName}</td>
                  <td>{subject.description} </td>
                  <td>{formatDate(subject.return_date)}</td>
                  <td>
                  <span style={{color: Number(subject.completion_status) === 1 ? 'green' : 'red'}}>{Number(subject.completion_status) === 1 ? '✓ Completed' : '✗ Incomplete'}</span>
                 
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
        {(homework.behavior_comments ) && (
          <div className="behavior-section mb-4">
            <h5>Behavior and Attitude / Well-being</h5>
            <p>{homework.behavior_comments}</p>
          </div>
        )}
        
        <div className="remarks-section mb-4">
          <h5>Teacher's Remarks</h5>
          <p>{homework.teacher_remarks || 'No remarks added'}</p>
        </div>
        
        <div className="parent-section mb-4">
          <h5>Parent's Response</h5>
          {editMode ? (
            <textarea
              className="form-control"
              rows={3}
              placeholder='Enter parent response'
              value={parentResponse}
              onChange={(e) => setParentResponse(e.target.value)}
            ></textarea>
          ) : (
            <p>{homework.parent_response || 'No parent response yet'}</p>
          )}
            
       
          {homework.parent_response_date && (
            <p className="text-muted">Response date: {formatDate(homework.parent_response_date)}</p>
          )}
        </div>
        
      </div>
    );
  };

  return (
    <div className="main-body">
      <div className="page-wrapper">
        {loading && <LoadEffect className="overlay floatLoad" />}
        
        <PageHeader title="Homework Preview">
          <li className="breadcrumb-item">
            <a href="#!"><i className="fa fa-fw fa-book"></i></a>
          </li>
          <li className="breadcrumb-item">
            <a href="#!">Academic</a>
          </li>
          <li className="breadcrumb-item">
            <a href="/homework">Homework</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#!">Preview</a>
          </li>
        </PageHeader>
        
        <div className="page-body">
          <div className="row">
            <div className="col-sm-12">
              <div className="card z-depth-0">
                <div className="card-header d-flex justify-content-between align-items-center">
                 
                 
                 
                  <h5><i className="fa fa-eye"></i> Homework Details</h5>
                  <div>
                    <button type="button" onClick={() => window.open('/homework/management', '_self')} className="btn btn-secondary mr-2" >
                      <i className="fa fa-arrow-left"></i> Back
                    </button>
                    <button 
                      type="button" 
                      className="btn btn-info mr-2" 
                      onClick={() => {
                        // Create a new window for printing
                        const printWindow = window.open('', '_blank');
                        // Write the printable content to the new window
                        printWindow.document.write(`
                          <html>
                            <head>
                              <title>Homework Preview</title>
                              <link rel="stylesheet" href="/assets/css/bootstrap.min.css">
                              <style>
                                body { 
                                  padding: 20px; 
                                  font-family: Arial, sans-serif;
                                }
                                .printable-homework {
                                  max-width: 800px;
                                  margin: 0 auto;
                                }
                                .img-100 {
                                  max-width: 100px;
                                  height: auto;
                                  display: block;
                                  margin: 0 auto;
                                }
                                .text-center {
                                  text-align: center;
                                }
                                table {
                                  width: 100%;
                                  border-collapse: collapse;
                                  margin-bottom: 20px;
                                }
                                table, th, td {
                                  border: 1px solid #ddd;
                                }
                                th, td {
                                  padding: 8px;
                                  text-align: left;
                                }
                                th {
                                  background-color: #f2f2f2;
                                }
                                h4, h5, h6 {
                                  margin-top: 10px;
                                  margin-bottom: 10px;
                                }
                                .student-info {
                                  margin-top: 20px;
                                  padding: 10px;
                                  background-color: #f9f9f9;
                                  border-radius: 5px;
                                }
                                @media print {
                                  body { 
                                    padding: 0; 
                                    font-size: 12pt;
                                  }
                                  .table-bordered {
                                    border: 1px solid #000 !important;
                                  }
                                  .table-bordered th, .table-bordered td {
                                    border: 1px solid #000 !important;
                                  }
                                  @page {
                                    margin: 0.5cm;
                                  }
                                }
                              </style>
                            </head>
                            <body>
                              ${printRef.current.innerHTML}
                            </body>
                          </html>
                        `);
                        // Wait for content to load then print
                        printWindow.document.close();
                        printWindow.onload = function() {
                          printWindow.focus();
                          printWindow.print();
                        };
                      }}
                    >
                      <i className="fa fa-print"></i> Print
                    </button>
                    {editMode ? (
                      <button type="button" className="btn btn-success" onClick={handleSaveChanges}>
                        <i className="fa fa-save"></i> Send Response
                      </button>
                    ) : (
                      <button type="button" className="btn btn-primary" onClick={handleEditToggle}>
                        <i className="fa fa-edit"></i> Reply
                      </button>
                    )}
                  </div>
                </div>
                <div className="card-block">
                  {error && <div className="alert alert-danger">{error}</div>}
                  {success && <div className="alert alert-success">{success}</div>}
                  
                  {homework && renderPrintableHomework()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeworkPreview;
